export default {
  getAdUnitsByAppId: (state, getters, rootState, rootGetters) => (appId) => {
    const mediation = rootGetters['monetization/currentMediation']
    return state.adUnits[mediation][appId]
  }
}
